module.exports = __webpack_public_path__ + "img/oil-temperature.7ff70d5d.svg";